import 'react';
import ChevronLeft from '../../icons/ChevronLeft.js';
import ChevronRight from '../../icons/ChevronRight.js';

const defaultProps = {
    pageSize: 10,
    numberPageButtonsOnPagination: 5,
    inBetweenPaginationButtonsLabel: '...',
    variant: 'primary',
    textAlign: 'left',
    paginationIconPrevious: ChevronLeft,
    paginationIconNext: ChevronRight,
    buttonSize: 32,
    numberOfColumns: 1,
    colSpan: 1,
};

export { defaultProps };
